module.exports = __webpack_public_path__ + "img/play.9b7d6e88.svg";